import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'guides',
    name: 'support-guides',
    redirect: '/support/guides/user-guide',
    children: [
      {
        path: 'user-guide',
        name: 'support-guides-user-guide',
        component: () => import('./views/UserGuide.view.vue'),
      },
    ],
  },
];
